import { render, staticRenderFns } from "./OzConfirmationDialogBox.vue?vue&type=template&id=676d6f66&"
import script from "./OzConfirmationDialogBox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzConfirmationDialogBox.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports